module.exports = __webpack_public_path__ + "static/img/アセット 57@3x.6f91a8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/アセット 57@3x.png
// module id = 07yX
// module chunks = 1